<template lang="pug">
div.faq
	h2 Covid 19 Precautions 50th Reunion
	p Doylestown has shown very few  reported new Covid cases  and Bucks County, as of this writing, has dropped most restrictions for large gatherings. The reunion committee highly recommends these  (OPTIONAL) covid prevention measures for your additional  health and safety:
	ol
		li
			ul
				li VACCINATE
				li BOOST YOURSELF
				li MASK UP INDOORS
				li TEST BEFORE COMING
				li WASH YOUR HANDS OFTEN 
				li STAY HOME IF YOU TEST POSITIVE OR IF YOU EXHIBIT  SYMPTOMS
			br
			br

		li
			ul
				li Both the Friday night gathering and the happy hour prior to dinner at the Doylestown Country Club (weather permitting) will have outdoor options.
				li For the main Saturday dinner and dance windows and doors will be open if possible to provide fresh air.
				li Check in will be spaced six feet apart. 
				li Names and contact info will be collected  Friday and Saturday Night , for future events and contact tracing. 
				li We are using larger tables for additional distancing.  
				li We have just under 150 attendees for Saturday which will provide a more spacious experience.  
				li We have had only 2 cancellations due to covid. 
				li Unfortunately, we cannot refund money if there are cancellations due to the fact that the vendors need to be paid.  

</template>

<script>

export default {
	name: 'Faq',
	components: {
	},
	data () {
		return {
		}
	}
}
</script>


<style lang="stylus" scoped>
h4
	span
		text-decoration underline
		display inline-block
		margin-right 5px
	em
		font-weight normal
h5
	font-size inherit
	margin 0
	
.indent
	padding-left 40px
	span
		text-decoration underline
		display inline-block
		margin-right 5px
	&.padding
		padding 20px
table
	th
		padding-right 20px
	th,
	td
		vertical-align top
		padding-bottom 40px
pre
	font-family inherit
	font-size inherit
	font-style normal
	margin 0
	white-space break-spaces
</style>